var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFornaxBiGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 40,
    viewBox: "0 0 155 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.719%",
    y1: "21.887%",
    x2: "75.719%",
    y2: "96.191%",
    id: "84a3crnvwa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4CEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5679F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.299%",
    y1: "100%",
    x2: "37.701%",
    y2: "0%",
    id: "xj8p8arqvb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64DF9B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "wh3t5j1fxc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#035D91",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#014B89",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.642 12.459a6.974 6.974 0 0 1 6.974 6.973l-.012 2.166a6.974 6.974 0 0 1-6.974 6.973h-3.593a6.974 6.974 0 0 1-6.974-6.973l.012-2.166a6.974 6.974 0 0 1 6.975-6.973zm84.511-.126 3.25.004a.184.184 0 0 1 .147.295l-5.898 7.816 5.898 7.816a.184.184 0 0 1-.147.296h-3.251a.186.186 0 0 1-.148-.074l-4.209-5.578-4.209 5.578a.185.185 0 0 1-.147.073h-3.25a.185.185 0 0 1-.148-.295l5.897-7.816-5.897-7.816a.185.185 0 0 1 .147-.295l3.25-.004c.057 0 .112.027.147.074l4.21 5.58 4.21-5.58a.186.186 0 0 1 .148-.074zm-23.66.148c2.268 0 3.185 1.7 3.487 2.259.224.452 1.717 3.484 3.2 6.496l.307.623 2.854 5.795.314.64a.183.183 0 0 1-.01.178.184.184 0 0 1-.156.087h-2.852a.185.185 0 0 1-.165-.102l-.122-.247-2.141-4.347h-6.755a.184.184 0 0 1-.184-.185v-2.592c0-.103.082-.185.184-.185h5.296l-2.38-4.833c-.365-.658-.637-.658-.878-.658-.327 0-.557.092-.836.574l-6.143 12.473a.186.186 0 0 1-.166.102h-2.852a.186.186 0 0 1-.157-.087.187.187 0 0 1-.008-.179l6.663-13.532c.535-.983 1.475-2.28 3.5-2.28zm-75.36.006c.103 0 .185.083.185.184v2.613c0 .049-.019.096-.054.13a.182.182 0 0 1-.13.054l-8.85-.004c-1.998 0-3.413 1.327-3.413 2.965v.623l11.924.048c.101 0 .183.083.183.185v2.592c0 .05-.019.096-.053.131a.189.189 0 0 1-.13.054h-.001l-11.922-.049.002 6.362a.184.184 0 0 1-.184.184h-2.601a.184.184 0 0 1-.184-.184V18.24c0-3.178 2.72-5.754 6.19-5.754h9.039zm38.048 0a4.235 4.235 0 0 1 4.23 4.23v.32c0 2.153-1.66 3.97-3.766 4.205l5.305 7.022a.184.184 0 0 1-.148.295h-3.254a.184.184 0 0 1-.148-.073l-5.454-7.218h-3.669a.184.184 0 0 1-.184-.185v-2.599c0-.102.082-.184.184-.184h6.907c.682 0 1.242-.556 1.248-1.237l.003-.346a1.242 1.242 0 0 0-.36-.892 1.241 1.241 0 0 0-.888-.37h-9.512v12.92a.184.184 0 0 1-.185.184h-2.599a.184.184 0 0 1-.184-.184V12.671c0-.102.082-.184.184-.184zm11.122-.02c.64 0 1.237.286 1.637.783l8.794 10.943v-11.54c0-.103.082-.185.184-.185h2.593c.102 0 .185.082.185.184V26.46c0 1.158-.942 2.1-2.1 2.1-.64 0-1.236-.286-1.636-.784l-8.795-10.938v11.519a.185.185 0 0 1-.184.184h-2.593a.184.184 0 0 1-.184-.184v-13.79c0-1.157.942-2.099 2.099-2.1zM66.37 15.419h-3.05a4.185 4.185 0 0 0-4.185 4.184l-.012 1.824a4.185 4.185 0 0 0 4.184 4.184h3.05a4.185 4.185 0 0 0 4.185-4.184l.012-1.824a4.184 4.184 0 0 0-4.184-4.184z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.63 1.715v9.083l2.613 1.83a4.556 4.556 0 0 1 1.944 3.732v8.408l8.24 5.771c1.007.704 2.39-.016 2.39-1.245V11.805c0-1.488-.726-2.88-1.944-3.733L13.02.472a1.496 1.496 0 0 0-.866-.278c-.788 0-1.524.626-1.524 1.521",
    fill: "url(#84a3crnvwa)",
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.762a4.56 4.56 0 0 0 1.943 3.733l10.854 7.6c1.006.703 2.39-.017 2.39-1.244v-9.083l-2.614-1.83a4.557 4.557 0 0 1-1.943-3.732v-8.408l-8.24-5.77A1.519 1.519 0 0 0 0 6.272v17.49z",
    fill: "url(#xj8p8arqvb)",
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.244 12.628-2.614-1.83v8.409c0 1.486.726 2.879 1.944 3.731l2.613 1.831v-8.41c0-1.486-.726-2.878-1.943-3.731",
    fill: "url(#wh3t5j1fxc)",
    transform: "translate(0 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFornaxBiGradient);
export default __webpack_public_path__ + "static/media/ico-fornax-bi-gradient.ae5a8ff5b06d9a245df762b25ec173c9.svg";
export { ForwardRef as ReactComponent };